import React from 'react';

import styles from './styles.module.scss';

const RectangleGrayDash = (props: { width?: string }) => (
  <img
    src={
      // eslint-disable-next-line max-len
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF0AAAAXCAYAAABpskPJAAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAzUlEQVRo3u2asQ3DIBBF2X8NKioWYAYGYAA6KgZwdEhEiRUrcEGk8HvSueMLPxsXdzbW2uNcGkIIx6esc8UYp7NlzUi27EHDSPZKL0Yu3vt2Y700pJTeMq4q5zydLWtGsmUPGkayV3jpD8D88oaA7sQi/R/SRbj26MD8p0Z8G1TsB+lIRzogHemAdKQD0pEOSEf6faRLr7qUgokN1FrbbIDW7kbopyP9htKdc018L23ga8ZVaeaYvfn/rbTDmJHsFV5kFv2Uzt8Ae/8GeADoeKdCxi9sHAAAAABJRU5ErkJggg=='
    }
    width={props.width || '28'}
    height="7"
    alt="gray-rec"
    aria-hidden
    className={styles.image}
  />
);

export default RectangleGrayDash;
